import { useEffect, useRef } from 'react';

import { supabase } from '../supabase.js';

export const useRealtimeTrigger = (domain, entity, callback, { onRemoved } = {}) => {
    const callbackRef = useRef(callback);
    const onRemovedRef = useRef(onRemoved);

    useEffect(() => {
        callbackRef.current = callback;
        onRemovedRef.current = onRemoved;
    }, [ callback, onRemoved ]);

    useEffect(() => {
        const channel = supabase
            .channel(`${ domain }-${ entity }`)
            .on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: 'realtime_triggers',
                filter: `domain=eq.${ domain },entity=eq.${ entity }`
            }, (payload) => {
                if (payload.eventType === 'DELETE' && onRemovedRef.current) {
                    onRemovedRef.current(payload.old.entity_id);
                } else if (callbackRef.current) {
                    callbackRef.current(payload.new.entity_id);
                }
            })
            .subscribe();

        return () => { supabase.removeChannel(channel); };
    }, [ domain, entity ]);
};
